export default "https://cdn-static.gokick.com/assets/f1ffb082694ccd599c5c343ec9cae3a0a74687d7/images/systolic-smaller.187d7732286412ba55022faa30794641.svg";